import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoOnly = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 9.065 13.913",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		stroke: "currentColor",
		d: "M100.443 106.956c-1.655-.555-3.307-.262-4.866.48-.395.188-1.407.884-1.122 1.451.302.6 1.929.403 2.462.374.985-.055 1.99-.31 2.833-.835.877-.545.961-1.288.663-2.235-.448-1.426-.89-2.831-1.026-4.332-.099-1.1-.067-2.312.403-3.335.409-.892 1.4-1.34 2.226-.628.588.507 1.008 2.026-.202 2.138-.262.025-.93.461-.36.408.673-.062 1.427-.268 1.816-.871.497-.77-.002-1.776-.73-2.196-1.384-.796-3.214.15-3.716 1.544-.621 1.729-.34 3.703.094 5.44.156.625.352 1.235.555 1.846.09.274.191.55.23.837.151 1.095-.878 1.565-1.81 1.739a6.7 6.7 0 0 1-2.055.038c-1.122-.153-.072-1.067.465-1.279 1.2-.472 2.186-.632 3.437-.213.22.074 1.001-.27.703-.37",
		style: { strokeWidth: .0933397 },
		transform: "translate(-94.405 -97.084)"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		stroke: "currentColor",
		d: "M94.44 108.867c.437 1.524 1.99 2.409 3.527 2.05 1.809-.42 2.741-2.11 2.557-3.891-.04-.386-.91-.177-.867.232.133 1.285-.444 2.807-1.845 3.081-1.16.227-2.196-.627-2.504-1.704-.112-.39-.978-.157-.867.232",
		style: { strokeWidth: .0933397 },
		transform: "translate(-94.405 -97.084)"
	})]
});
export default SvgLogoOnly;
